import { TextareaAutosize } from '@material-ui/core'
import React, { FC, ReactElement, useContext } from 'react'
import {
    Controller,
    ControllerRenderProps,
    useFormContext,
    UseFormMethods
} from '../../../../Vendor/react-hook-form/dist/index.ie11'
import { EMPTY_STRING } from '../../../../NonReact/constants/Common'
import { CommonFormContext, FormContextType } from '../../Contexts/CommonFormContext'
import { IsVarEmpty } from '../../../../NonReact/utils/GlobalFunctions'

export type TextAreaProps = {
    name: string
    label?: string
    disabled?: boolean
    additionalClassNames?: string
}

export const TextArea: FC<TextAreaProps> = ({
    name,
    label,
    disabled,
    additionalClassNames
}: TextAreaProps): ReactElement => {
    const commonForm: Nullable<FormContextType> = useContext(CommonFormContext)
    const { control }: UseFormMethods = useFormContext()

    const props = {
        control,
        name,
        defaultValue: EMPTY_STRING,
        render: ({ onChange, value }: ControllerRenderProps<Record<string, unknown>>): ReactElement => (
            <div className={`text-area-wrapper`}>
                <TextareaAutosize
                    disabled={disabled}
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    value={value}
                    className={additionalClassNames}
                    onChange={(e): void => {
                        if (commonForm?.handleFormChange) {
                            commonForm?.handleFormChange(name)
                        }

                        onChange(e)
                    }}
                />
            </div>
        )
    }

    return (
        <div className='text-area'>
            {IsVarEmpty(label) ? <label className='label'>{label}</label> : <></>}
            <Controller {...props} />
        </div>
    )
}
